import { FiMail, FiPhone, FiGlobe, FiZap, FiDatabase, FiCpu } from 'react-icons/fi';

export const WhoWeAreContent = () => {
  const features = [
    {
      icon: <FiCpu className="w-6 h-6" />,
      title: "AI-Powered Discovery",
      description:
        "Intelligent search across thousands of AI use cases, startups, and solution providers powered by advanced language models.",
    },
    {
      icon: <FiDatabase className="w-6 h-6" />,
      title: "Comprehensive Data",
      description:
        "Access a rich database of startups, VCs, acquisition targets, and solution providers across every major industry sector.",
    },
    {
      icon: <FiGlobe className="w-6 h-6" />,
      title: "Global Ecosystem",
      description:
        "Explore companies and opportunities from India, the US, Europe, Southeast Asia, and beyond — all in one platform.",
    },
    {
      icon: <FiZap className="w-6 h-6" />,
      title: "Real-Time Insights",
      description:
        "Stay ahead with live signals, trending use cases, and AI-driven analysis of emerging market opportunities.",
    },
  ];

  return (
    <div className="space-y-10">
      {/* Header */}
      <header>
        <h2
          style={{
            fontFamily: 'Sora, sans-serif',
            fontWeight: 600,
            fontSize: '32px',
            lineHeight: '150%',
            color: 'rgba(255, 84, 31, 1)',
          }}
          className="mb-4"
        >
          Who We Are
        </h2>
        <div className="mb-6">
          <span
            style={{
              fontFamily: 'Sora, sans-serif',
              fontWeight: 700,
              fontSize: '24px',
              lineHeight: '200%',
              color: 'rgba(255,255,255,1)',
            }}
            className="block mb-2"
          >
            BigDataMatica — Powering Intelligence-Driven Decisions
          </span>
          <span
            style={{
              fontFamily: 'Sora, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '175%',
              color: 'rgba(140, 140, 140, 1)',
            }}
            className="block"
          >
            We are BigDataMatica, a technology company dedicated to building AI-powered platforms
            that help organizations discover, evaluate, and act on intelligent insights. The
            AI-Powered UCDP (Use Case Discovery Platform) is our flagship product — a comprehensive
            ecosystem connecting startups, investors, acquirers, and solution seekers through
            advanced AI.
          </span>
        </div>
      </header>

      {/* What We Do */}
      <section className="rounded-xl border border-white/10 bg-black/40 backdrop-blur-sm p-6 md:p-8">
        <h3
          style={{
            fontFamily: 'Sora, sans-serif',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '150%',
            color: 'rgba(255, 255, 255, 1)',
            letterSpacing: '0.01em',
          }}
          className="mb-6"
        >
          What We Do
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="flex flex-col justify-start px-4 py-6 bg-black/50 rounded-lg border border-white/10"
            >
              <div className="text-orange-400 mb-3">{item.icon}</div>
              <h4
                style={{
                  fontFamily: 'IBM Plex Sans, sans-serif',
                  fontWeight: 700,
                  fontSize: '20px',
                  lineHeight: '150%',
                  color: 'rgba(255,255,255,1)',
                  marginBottom: '10px',
                  letterSpacing: '0.01em',
                }}
              >
                {item.title}
              </h4>
              <p
                style={{
                  fontFamily: 'Lora, serif',
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '160%',
                  color: 'rgba(200,200,200,1)',
                  letterSpacing: '0.01em',
                }}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="rounded-xl border border-white/10 bg-black/40 backdrop-blur-sm p-6 md:p-8">
        <h3
          style={{
            fontFamily: 'Sora, sans-serif',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '150%',
            color: 'rgba(255, 255, 255, 1)',
          }}
          className="mb-6"
        >
          Get In Touch
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col justify-start px-4 py-6 bg-black/50 rounded-lg border border-white/10">
            <div className="text-orange-400 mb-3">
              <FiMail className="w-6 h-6" />
            </div>
            <h4
              style={{
                fontFamily: 'IBM Plex Sans, sans-serif',
                fontWeight: 700,
                fontSize: '18px',
                lineHeight: '150%',
                color: 'rgba(255,255,255,1)',
                marginBottom: '8px',
              }}
            >
              Email Us
            </h4>
            <a
              href="mailto:contactus@bigdatamatica.com"
              style={{
                fontFamily: 'Lora, serif',
                fontSize: '16px',
                lineHeight: '150%',
                color: 'rgba(255,84,31,1)',
                textDecoration: 'none',
              }}
            >
              contactus@bigdatamatica.com
            </a>
          </div>
          <div className="flex flex-col justify-start px-4 py-6 bg-black/50 rounded-lg border border-white/10">
            <div className="text-orange-400 mb-3">
              <FiPhone className="w-6 h-6" />
            </div>
            <h4
              style={{
                fontFamily: 'IBM Plex Sans, sans-serif',
                fontWeight: 700,
                fontSize: '18px',
                lineHeight: '150%',
                color: 'rgba(255,255,255,1)',
                marginBottom: '8px',
              }}
            >
              Call Us
            </h4>
            <a
              href="tel:+918147100993"
              style={{
                fontFamily: 'Lora, serif',
                fontSize: '16px',
                lineHeight: '150%',
                color: 'rgba(255,84,31,1)',
                textDecoration: 'none',
              }}
            >
              +91 8147100993
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhoWeAreContent;
